import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.893 18.625l.138.138c-2.38 2.38-7.398 1.222-11.207-2.587C.014 12.367-1.143 7.35 1.237 4.97l.138.138c.188-.369.43-.705.724-1l1.725 1.724c-1.215 1.214-.391 4.782 2.586 7.76 2.977 2.976 6.545 3.8 7.759 2.585l1.724 1.725a3.931 3.931 0 0 1-1 .724zM5.548 7.555l-3.449 3.449L.375 9.28l2.587-2.587L1.237 4.97l.862-.862a1.22 1.22 0 0 1 1.725 0l1.724 1.724a1.22 1.22 0 0 1 0 1.724zm6.897 6.897a1.22 1.22 0 0 1 1.724 0l1.724 1.724a1.22 1.22 0 0 1 0 1.725l-.862.862-1.724-1.725-2.587 2.587L8.996 17.9l3.449-3.449zM10 2.222V0c5.523 0 10 4.477 10 10h-2.222A7.778 7.778 0 0 0 10 2.222zM10 7V5a5 5 0 0 1 5 5h-2a3 3 0 0 0-3-3z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-emergency"}) } }